import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB6yBoDDY3kcZqNeTDAFMfmiuQ9zDzywQA",
  authDomain: "youshow-client-auth.firebaseapp.com",
  projectId: "youshow-client-auth",
  storageBucket: "youshow-client-auth.appspot.com",
  messagingSenderId: "102362072562",
  appId: "1:102362072562:web:6606a04855fdcae91e976b"
};

export default firebaseConfig;
